import {StrictMode} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import Root from './Root.tsx';
import './index.css';
import { captureTrackingParams } from './lib/trackingParams';

captureTrackingParams();

const container = document.getElementById('root')!;
const app = (
  <StrictMode>
    <Root />
  </StrictMode>
);

// The production build prerenders the page into #root (scripts/prerender.mjs);
// hydrate that markup. In dev the root is empty, so render normally.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
